import { render, staticRenderFns } from "./q-number.vue?vue&type=template&id=1f6c1ffd&scoped=true&"
import script from "./q-number.vue?vue&type=script&lang=js&"
export * from "./q-number.vue?vue&type=script&lang=js&"
import style0 from "./q-number.vue?vue&type=style&index=0&id=1f6c1ffd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c1ffd",
  null
  
)

export default component.exports